module.exports = __webpack_public_path__ + "5673b361af22089139bd443516f6e707.csv";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/directory-groups/directory/import-users/import-users-sample.csv
// module id = 1729
// module chunks = 0